import React from "react";
import PropTypes from "prop-types";
import BaseIcon from "../../../../components/BaseIcon";
import { Tooltip } from "@mui/material";
import Game from "../../../../store/Game";
import { useTranslation } from "react-i18next";
import "./style.scss";

export default function UserInfoTitle({
  icon,
  name,
  age,
  hideMatches,
  gameId,
}) {
  const { t } = useTranslation();

  UserInfoTitle.propTypes = {
    icon: PropTypes.string,
    name: PropTypes.string,
    age: PropTypes.number,
    gameId: PropTypes.number,
    hideMatches: PropTypes.bool,
  };
  const matches = Game.countPartnerGameMatches(gameId);
  return (
    <div className="title-container">
      <div className="title">
        <span>
          {name || age ? (
            `${name}${typeof age === "undefined" ? "" : ` ${age}`}`
          ) : (
            <div className="loader" />
          )}
        </span>
        <BaseIcon name={icon} className="title__icon" />
      </div>
      {!hideMatches && matches ? (
        <div className="tooltip-сontainer-mobile">
          <Tooltip
            enterTouchDelay={0}
            title={t("matchesTip")}
            arrow
            placement={"left"}
          >
            <div className="person-pair__matches">
              <div className="person-pair__matches__count">
                {matches.coincidences?.negative?.length +
                  matches.coincidences?.positive?.length +
                  matches.coincidences?.neutral?.length}
              </div>
              <BaseIcon name="mozaika1" />
            </div>
          </Tooltip>
        </div>
      ) : null}
    </div>
  );
}
